import { render, staticRenderFns } from "./sideRank.vue?vue&type=template&id=54c73c7f&scoped=true&"
import script from "./sideRank.vue?vue&type=script&lang=js&"
export * from "./sideRank.vue?vue&type=script&lang=js&"
import style0 from "./sideRank.vue?vue&type=style&index=0&id=54c73c7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c73c7f",
  null
  
)

export default component.exports